import React from "react";
import cx from "classnames";
import AppStoreIcon from "../../../../assets/svgs/app-store-icon-dark.svg";
import GooglePlayIcon from "../../../../assets/svgs/google-play-icon-dark.svg";
import MenuArrowIcon from "../../../../assets/svgs/menu-arrow-next.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import SignUpButton from "../../../SignUpButton";

const MobileMenu = ({ setMenuPage, t, siteCountry }) => {
  const Menu = ({ children, classNames, name }) => (
    <button
      className={cx("btn d-flex justify-content-between px-0", classNames)}
      onClick={() => setMenuPage(name)}
    >
      <h5>{children}</h5>
      <MenuArrowIcon />
    </button>
  );

  return (
    <div className="mobile-menu d-flex flex-column justify-content-between h-100">
      <div className="container">
        <div className="d-flex flex-column mt-3 w-100">
          {/* <span className="title mb-3">{t("menu.mobile.title")}</span> */}

          <Menu name="trade">{t("menu.trade.title")}</Menu>

          <Menu name="earn">{t("menu.earn.title")}</Menu>

          {siteCountry === "th" && (
            <Menu name="explore">{t("menu.explore.title")}</Menu>
          )}

          <Menu name="campaigns">{t("menu.campaigns.title")}</Menu>

          <Menu name="company">{t("menu.company.title")}</Menu>

          <Menu name="support">{t("menu.support.title")}</Menu>

          <Menu name="learn">{t("menu.learn.title")}</Menu>

          <SignUpButton className="btn btn-primary mt-5 mb-3">
            {t("menu.btnGetStarted")}
          </SignUpButton>
        </div>
      </div>
      <div className="footer pb-4 pt-3">
        <div className="container justify-content-start">
          <div className="mobile__lang-switch ">
            <LanguageSwitcher className="mr-1 mb-2 px-2 py-2" />
          </div>
          <a
            className="mr-1 d-flex"
            href="https://zipmex.onelink.me/8NSq/15940e3a"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <AppStoreIcon />
          </a>

          <a
            className="mr-1 d-flex"
            href="https://zipmex.onelink.me/8NSq/15940e3a"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <GooglePlayIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
